import React from "react";

const DadosCredenciamentoCard = ({ dadosCredenciamento }) => (
  <div className="col-lg-12">
    <div className="card shadow mb-1">
      <div className="card-header">
        <b>Credenciamento</b>
      </div>
      <div className="card-body">
        {" "}
        <center>
          <table className="table table-striped table-bordered" width="80%">
            <thead>
              <tr>
                <th>
                  <center>Tipo de Credenciamento</center>
                </th>
                <th>
                  <center>Data Inicial</center>
                </th>
                <th>
                  <center>Data Final</center>
                </th>
              </tr>
            </thead>
            <tbody>
              {dadosCredenciamento?.map((credenciamento) => (
                <tr>
                  <td>{credenciamento.descricaoCredenciamento}</td>
                  <td>
                    <center>{credenciamento.dataInicio}</center>
                  </td>
                  <td>
                    <center>{credenciamento.dataFim}</center>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </center>
      </div>
    </div>
  </div>
);

export default DadosCredenciamentoCard;
